import React, { InputHTMLAttributes } from 'react'
import styled from 'styled-components'

import { IconCheckboxCheck } from 'components/Icons/IconCheckboxCheck'
import { IconCheckboxNotCheck } from 'components/Icons/IconCheckboxNotCheck'
import { Typography } from 'components/Typography/Typography'

interface CheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string
}

const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
`

const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  border: 0;
  clip: rect(0 0 0 0);
  clippath: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`

const StyledCheckbox = styled.div<{ checked: boolean }>`
  display: inline-block;
  width: 20px;
  height: 20px;
  border-radius: 3px;
  transition: all 150ms;
  cursor: pointer;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  ${HiddenCheckbox}:focus + & {
    box-shadow: 0 0 0 3px pink;
  }
`

const CheckboxLabel = styled.label`
  margin-left: 4px;
  cursor: pointer;
`

const Checkbox: React.FC<CheckboxProps> = ({ label, checked, onChange, ...props }) => (
  <CheckboxContainer>
    <HiddenCheckbox
      {...(checked !== undefined ? { checked } : {})}
      {...(onChange ? { onChange } : { readOnly: true })}
      {...props}
    />
    {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
    <StyledCheckbox checked={checked || false} onClick={onChange as any}>
      {checked ? <IconCheckboxCheck /> : <IconCheckboxNotCheck />}
    </StyledCheckbox>
    {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
    <CheckboxLabel onClick={onChange as any}>
      <Typography variant="caption" fontWeight="medium">
        {label}
      </Typography>
    </CheckboxLabel>
  </CheckboxContainer>
)

export default Checkbox
